import { render, staticRenderFns } from "./ImportMaterial.vue?vue&type=template&id=3e874356&scoped=true"
import script from "./ImportMaterial.vue?vue&type=script&lang=js"
export * from "./ImportMaterial.vue?vue&type=script&lang=js"
import style0 from "./ImportMaterial.vue?vue&type=style&index=0&id=3e874356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e874356",
  null
  
)

export default component.exports